import React from 'react';
import ProjectPage from '../../components/projects/ProjectPage';
import m2Data from '../../data/projects/m2.js';

function M2() {
  return <ProjectPage projectData={m2Data} />;
}

export default M2;

